import { createStore } from "vuex";

import rootMutations from "./rootMutations.js";
import rootGetters from "./rootGetters.js";
import rootActions from "./rootActions.js";

import playerDataModule from './modules/playerData/index.js';

export default createStore({
  modules:{
        gamer : playerDataModule
  },
  state() {
    return {
      profitView: true,
      selectedCurrency: "pound",
      currencyRate: {
        pound: 1.00,
        euro: 1.17,
        dollar: 1.37,
      },
      currencySymbol:{
        pound: '£',
        euro: "€",
        dollar: '$'
      },
      timer: 0,
      timeUnits: "MINUTES",
      timeConversion: {
        SECONDS: 1,
        MINUTES: 60,
        HOURS: 3600,
        DAYS: 86400,
      },
      sortCategory:null,
      sortDirection:1,
    };
  },
  mutations: rootMutations,
  getters: rootGetters,
  actions: rootActions,
});
